module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/global-variables.json
// module id = 315
// module chunks = 116